const reducersName = 'searchCars'

export const searchCarsSelectors = {
	getItems: (state) => state[reducersName].items,
	getMeta: (state) => state[reducersName].meta,
	getParams: (state) => state[reducersName].params,
	getAll: (state) => state[reducersName]
}
